import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { Box, MenuItem, Select, Tab, Tabs, useMediaQuery } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";

// Hooks
import { useFeatureFlag } from "../../../hooks/useFeatureFlags";

// Components
import LPRPlateSearchTab from "../../../components/LPRSearch/LPRPlateSearchTab";
import LPRScoringContainer from "../../../components/LPRScoring/LPRScoringContainer";

const TABS = [
  {
    value: "plateSearch",
    label: "Plate Search",
    Icon: SearchIcon,
    className: "lpr-tab-plate-search",
  },
  {
    value: "cameraScoring",
    label: "Camera Scoring",
    Icon: PhotoCameraIcon,
    className: "lpr-tab-camera-scoring",
  },
];

const useStyles = makeStyles((theme) => ({
  tabBar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    marginBottom: theme.spacing(2),
  },
  mobileSelect: {
    marginBottom: theme.spacing(2),
  },
  menuIcon: {
    marginRight: theme.spacing(1),
    verticalAlign: "middle",
  },
}));

const LPRPage = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));

  const lprFeatureFlag = useFeatureFlag("LPR");

  const [activeTab, setActiveTab] = useState("plateSearch");
  const [mounted, setMounted] = useState({ plateSearch: true });

  const handleTabChange = (value) => {
    setActiveTab(value);
    setMounted((prev) => ({ ...prev, [value]: true }));
  };

  if (!lprFeatureFlag) {
    return <Redirect to="/home" />;
  }

  return (
    <Box>
      {isXs ? (
        <Box className={classes.mobileSelect}>
          <Select
            fullWidth
            variant="outlined"
            value={activeTab}
            onChange={(e) => handleTabChange(e.target.value)}
          >
            {TABS.map((t) => (
              <MenuItem key={t.value} value={t.value} className={t.className}>
                <t.Icon fontSize="small" className={classes.menuIcon} />
                {t.label}
              </MenuItem>
            ))}
          </Select>
        </Box>
      ) : (
        <Box className={classes.tabBar}>
          <Tabs
            centered
            variant="fullWidth"
            value={activeTab}
            onChange={(_, value) => handleTabChange(value)}
            textColor="inherit"
            indicatorColor="secondary"
          >
            {TABS.map((t) => (
              <Tab
                key={t.value}
                value={t.value}
                icon={<t.Icon />}
                label={t.label}
                className={t.className}
              />
            ))}
          </Tabs>
        </Box>
      )}

      {(mounted.plateSearch || activeTab === "plateSearch") && (
        <div hidden={activeTab !== "plateSearch"}>
          <LPRPlateSearchTab />
        </div>
      )}

      {(mounted.cameraScoring || activeTab === "cameraScoring") && (
        <div hidden={activeTab !== "cameraScoring"}>
          <LPRScoringContainer />
        </div>
      )}
    </Box>
  );
};

export default LPRPage;
